export default (applicationCargoPickupTime) => ({
    cargoTimePickup: [
        {
            validator: (rule, value, callback) => {
              if ( applicationCargoPickupTime.cargoTimePickup == "" ) {
                callback(new Error("Пожалуйста укажите время забора"));
              }
              callback();
            },
            trigger: "blur",
        },
    ],
    cargoTimePickupDelivery: [
        {
            validator: (rule, value, callback) => {
              if ( applicationCargoPickupTime.cargoTimePickupDelivery == "" ) {
                callback(new Error("Пожалуйста укажите время доставки"));
              }
              callback();
            },
            trigger: "blur",
        },
    ],
});